import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitcharacter',
})
export class LimitcharacterPipe implements PipeTransform {
  transform(value?: string, limit?: number): unknown {
    if (!value) return value;
    if (!limit) return value;

    const valueLenght = value.length;
    if (valueLenght <= limit) return value;
    return `${value.substring(0, limit)}...`;
  }
}
